import { SxProps, Theme } from "@mui/material/styles";
import * as Global from "styles/global/global.styles";
import { zIndex } from '../../../../styles/global/global.styles';
import { AlertColor } from "@mui/material";

export function cardCSS(theme: Theme): SxProps<Theme> {
  return {
    my: "50px",
    mx: { sm: "10rem", lg: "20rem" },
    borderRadius: "30px",
  };
}

export function containerCSS(theme: Theme): SxProps<Theme> {
  return {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    // width: { xs: "100vw", sm: "auto" },
    // height: { xs: "55vh" },
    backgroundColor: {
      xs: Global.colors().__content.contentBackground,
      md: "transparent"
    },
    my: { xs: "2rem" },
    p: { sm: "1rem 3rem" },
    maxWidth: { xs: "390px", sm: "500px", md: "550px" },
  };
}

export function headerCSS(theme: Theme): SxProps<Theme> {
  return {
    color: Global.colors().headers,
    textTransform: "uppercase",
    fontSize: { xs: "28px",sm: "35px" },
    textAlign: { xs: "center" },
  };
}

export function textCSS(theme: Theme): SxProps<Theme> {
  return {
    textAlign: "justify",
    px: { xs: "2rem", sm: "1rem" },
    my: { xs: "1rem" },
  };
}

interface WarningCSSProps {
  __self: SxProps<Theme>;
  __warningTitle: SxProps<Theme>;
  __warningTitleBox: SxProps<Theme>;
  __warningIcon: SxProps<Theme>;
  __warningText: SxProps<Theme>;
}

export function warningCSS(theme: Theme): WarningCSSProps {
  return {
    __self: {
      //   fontWeight: "bold",
      fontSize: "13px",
      border: `1px solid ${Global.colors().__warning.background}`,
      borderRadius: "20px",
      backgroundColor: Global.colors().__warning.background,
      boxShadow: "0px 5px 5px 0px rgba(229,218,184,0.8)",
      padding: "20px",
      pr: "35px",
      display: "flex",
      alignItems: "start",
      //   flexDirection: "row",
      //   textAlign: "flexStart",
    },
    __warningTitle: {
      alignSelf: "flex-start",
      fontWeight: "bold",
      fontSize: "15px",
      pb: "5px",
    },
    __warningIcon: {
      color: Global.colors().__warning.text,
      fontSize: "20px",
      mr: "10px",
      flexGrow: "1",
      alignSelf: "flex-start",
    },
    __warningTitleBox: {
      display: "flex",
      flexDirection: "column",
      textAlign: "start",
    },
    __warningText: {
      flexGrow: "4",
      color: Global.colors().__warning.text,
    },
  };
}

export function buttonCSS(theme: Theme): SxProps<Theme> {
  return {
    borderRadius: "100px",
    height: "50px",
    width: "300px",
    my: { xs: "1rem"},
    py: {xs: "3vh", md: '0'}
  };
}

export function AlertCSS(severity: AlertColor): AlertCSSProps {
  switch (severity) {
    case "error":
      return {
        __style: {
          display: "flex",
          alignItems: "center",
          backgroundColor: Global.colors().__attention.error.background,
          color: Global.colors().__attention.error.text,
          border: `2px solid ${Global.colors().__attention.error.borderColor}`,
          borderRadius: "15px",
          px: "1.5rem",
        },
        __postion: {
          bottom: "100px !important",
          right: "1rem !important",
          left: "1rem !important",
        },
      };
    case "warning":
      return {
        __style: {
          display: "flex",
          alignItems: "center",
          backgroundColor: Global.colors().__attention.warning.background,
          color: Global.colors().__attention.warning.text,
          border: `2px solid ${
            Global.colors().__attention.warning.borderColor
          }`,
          borderRadius: "15px",
          px: "1.5rem",
        },
        __postion: {
          bottom: "100px !important",
          right: "1rem !important",
          left: "1rem !important",
        },
      };
    case "info":
      return {
        __style: {
          display: "flex",
          alignItems: "center",
          backgroundColor: Global.colors().__attention.info.background,
          color: Global.colors().__attention.info.text,
          border: `2px solid ${Global.colors().__attention.info.borderColor}`,
          borderRadius: "15px",
          px: "1.5rem",
          right: "24px !important",
        },
        __postion: {
          bottom: "10px !important",
          right: "1rem !important",
          left: "1rem !important",
        },
      };
    case "success":
      return {
        __style: {
          display: "flex",
          alignItems: "center",
          backgroundColor: Global.colors().__attention.success.background,
          color: Global.colors().__attention.success.text,
          border: `2px solid ${
            Global.colors().__attention.success.borderColor
          }`,
          borderRadius: "15px",
          px: "1.5rem",
        },
        __postion: {
          bottom: "100px !important",
          right: "1rem !important",
          left: "1rem !important",
        },
      };
  }
}

interface AlertCSSProps {
  __style: SxProps<Theme>;
  __postion: SxProps<Theme>;
}